import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { goBack } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import {
  Button,
  Container,
  Menu,
} from 'semantic-ui-react';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import { promptChangesMessage, promptChangesLeave } from '../../actions/prompt';
import NavBar from '../../components/NavBar';
import Form from './Form';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class New extends Component {
  static propTypes = {
    token: PropTypes.string,
    loading: PropTypes.bool,
    onCheck: PropTypes.func,
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      hasChanges: false,
    };
  }
  async submit(validations, preset) {
    const { t } = this.props;
    const { store } = this.context;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      return;
    }
    let res;
    try {
      res = await this.form.submit('/specifications/units/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(preset),
      });
    } catch (err) {
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.setState({ hasChanges: false }, () => {
      this.handleOnCheck(false, (noChanges) => {
        if (noChanges) {
          store.dispatch(goBack());
          store.dispatch(flashSuccessMessage({ header: t('Create Success', { ns: TRANSLATION_FILES.translation }), message: t('{{name}} successfully created', { ns: TRANSLATION_FILES.translation, name: res.name }) }));
        }
      });
    });
  }
  handleSubmit = (event) => {
    this.form.handleSubmit(event);
  }
  handleOnChange = (hasChanges) => {
    if (hasChanges !== this.state.hasChanges) {
      this.setState({ hasChanges }, () => {
        this.handleOnCheck(hasChanges);
      });
    }
  }
  handleOnCheck = (hasChanges = false, callback) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges, callback);
    }
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('New preset', { ns: TRANSLATION_FILES.translation })}
          rightNav={
            <Menu.Item fitted>
              <Button
                positive
                content={t('Create', { ns: TRANSLATION_FILES.screens })}
                onClick={this.handleSubmit}
                disabled={!this.state.hasChanges}
              />
            </Menu.Item>
          }
        />
        <Form
          ref={(ref) => { this.form = ref; }}
          onSubmit={(validations, preset) => {
            this.submit(validations, preset);
          }}
          onChange={this.handleOnChange}
          loading={this.props.loading}
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(New);



// WEBPACK FOOTER //
// ./src/containers/ProjectUnitSpecifications/New.jsx